var angular = require('angular');

var ngModule = angular.module('imageCropper', []);

var Cropper = require('./imageCropper');
require('./imageCropperDirective')(angular, Cropper);

module.exports = 'imageCropper';


/*****************
 ** WEBPACK FOOTER
 ** ./index.js
 ** module id = 0
 ** module chunks = 0
 **/